import type { PlayerTrack } from './player-context'

/**
 * Pont (module-level, hors React) entre le party-context et le player-context.
 *
 * Le player-context est MONTÉ AU-DESSUS du party-context : il ne peut pas
 * appeler useParty(). Ce pont permet quand même à `play()` de savoir si on est
 * en soirée et, le cas échéant, d'envoyer le morceau à la baffle au lieu de le
 * jouer en local.
 *
 *   - inParty : true uniquement pour un INVITÉ connecté.
 *   - target  : destination par défaut quand on tape un morceau.
 *               'baffle' → envoyé à la baffle ; 'phone' → joué en local.
 *   - send    : envoie le morceau à la file de la baffle.
 *
 * Le PartyProvider met à jour ces champs via un effet.
 */
export type PlayTarget = 'baffle' | 'phone'

type PartyBridge = {
  inParty: boolean
  target: PlayTarget
  send: (track: PlayerTrack) => void
}

export const partyBridge: PartyBridge = {
  inParty: false,
  target: 'baffle',
  send: () => {},
}
